import gql from 'graphql-tag'

export const GET_ALL_EVENT_CATEGORIES = gql`
  query getAllEventCategories {
    getAllEventCategories {
      id
      name
      subCategoryLabel
      imageUrl
      description
      subCategories {
        organizationId
        id
        name
        type
      }
    }
  }
`
